export const phoneNumberRegex = /^([0-9]){10}$/;

export const CNIC_REGEX = /^([0-9]){13}$/;

export const englineNumberRegex = /^[A-Za-z0-9 /_-]*$/;

// const phoneNumberRegex =  new RegExp(/^((\+92)|(0092))(3[0-4][0-9]|35[0-9])\d{7}$/);
// const phoneNumberRegex =  new RegExp(/^(3[0-4][0-9]|35[0-9])$/);
/**
 * Validate Phone Number
 * @param phone {Phone Number}
 */
export const onlyNumberRegex = new RegExp(/^\d+$/);
const emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
const nameRegex = new RegExp(/^[a-zA-Z ]*$/);
export const verifyNumber = (number: any): boolean => onlyNumberRegex.test(number);
export const verifyName = (name: any): boolean => nameRegex.test(name);
export const verifyEmail = (email: any): boolean => emailRegex.test(email);
